<template>
  <article class="ViewStoriesStory">
    <div class="ViewStoriesStory__image-wrapper">
      <div class="ViewStoriesStory__image-ratio">
        <BaseImage
          v-if="image"
          :id="image"
          class="ViewStoriesStory__image"
        />
        <CourtFull
          expand
          sidelines
          class="ViewStoriesStory__court"
        />
      </div>
    </div>
    <div class="ViewStoriesStory__content">
      <h2
        is="TextBeta"
        class="ViewStoriesStory__title"
        v-html="title"
      />
      <ul class="ViewStoriesStory__products">
        <li
          v-for="id in products"
          :key="id"
          class="ViewStoriesStory__product"
        >
          <StoryProduct :id="id"/>
        </li>
      </ul>
      <div class="ViewStoriesStory__copy">
        <div v-html="splitContent[0]"/>
        <DisclosureContainer
          v-if="splitContent[1]"
          :id="containerId"
          transition="TransitionSlide"
          class="ViewStoriesStory__copy-rest"
          @toggle="expanded = !expanded"
          v-html="splitContent[1]"
        />
        <DisclosureButton
          v-if="splitContent[1]"
          :controls="containerId"
          class="ViewStoriesStory__button"
        >
          <TextEpsilon
            class="ViewStoriesStory__button-text"
            v-text="!expanded ? 'Read More' : 'Close'"
          />
          <DisclosureIndicator
            :expanded="expanded"
            class="ViewStoriesStory__button-indicator"
          />
        </DisclosureButton>
      </div>
    </div>
  </article>
</template>

<script>
  import TextBeta from './TextBeta';
  import CourtFull from './CourtFull';
  import TextEpsilon from './TextEpsilon';
  import StoryProduct from './StoryProduct';
  import DisclosureButton from './DisclosureButton';
  import DisclosureContainer from './DisclosureContainer';
  import DisclosureIndicator from './DisclosureIndicator';

  export default {
    components: {
      TextBeta,
      CourtFull,
      TextEpsilon,
      StoryProduct,
      DisclosureButton,
      DisclosureContainer,
      DisclosureIndicator,
    },
    props: {
      title: {
        type: String,
        required: true,
      },
      content: {
        type: String,
        required: true,
      },
      image: {
        type: [Number, Boolean],
        default: null,
      },
      products: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        expanded: false,
      };
    },
    computed: {
      containerId() {
        return `container-${this._uid}`;
      },
      splitContent() {
        const [first, ...rest] = this.content.match(/<p>.*?<\/p>/g);

        return [
          first,
          rest.join(''),
        ];
      },
    },
  };
</script>

<style lang="scss">
  .ViewStoriesStory {
    @include breakpoint(phablet) {
      display: flex;
    }
  }

  .ViewStoriesStory__button {
    margin-top: spacing(base-beta);
    display: flex;
    padding-top: spacing(base-alpha);
    padding-bottom: spacing(base-alpha);
    align-items: center;

    &:focus {
      outline-style: none;
    }
  }

  .ViewStoriesStory__button-indicator {
    margin-left: spacing(base-alpha);

    .ViewStoriesStory__button & .line {
      transition-property: border-color;
      transition-duration: duration(fast);
      transition-timing-function: timing-function(standard);
    }

    .ViewStoriesStory__button:focus & .line,
    .ViewStoriesStory__button:hover & .line {
      border-color: color(red);
    }
  }

  .ViewStoriesStory__button-text {
    color: color(bronze);
    transition-property: color;
    transition-duration: duration(fast);
    transition-timing-function: timing-function(standard);

    .ViewStoriesStory__button:focus &,
    .ViewStoriesStory__button:hover & {
      color: color(red);
    }
  }

  .ViewStoriesStory__content {
    margin-top: spacing(base-gamma);

    @include breakpoint(phablet) {
      margin-top: 0;
      padding-right: spacing(base-gamma);
      padding-left: spacing(base-gamma);
      width: 60%;
    }
  }

  .ViewStoriesStory__copy {
    margin-top: spacing(base-beta);
    line-height: line-height(copy);
  }

  .ViewStoriesStory__copy-rest {
    margin-top: spacing(base-beta);
  }

  .ViewStoriesStory__court {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    color: color(bronze);
    padding: spacing(base-beta);
  }

  .ViewStoriesStory__image {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .ViewStoriesStory__image-ratio {
    position: relative;
    padding-top: 100%;
  }

  .ViewStoriesStory__image-wrapper {
    @include breakpoint(phablet) {
      padding-right: spacing(base-gamma);
      padding-left: spacing(base-gamma);
      width: 40%;
    }
  }

  .ViewStoriesStory__products {
    display: flex;
    flex-wrap: wrap;
    margin-top: spacing(base-beta);
  }

  .ViewStoriesStory__title {
    color: color(bronze);
  }
</style>
